import { Await, useLoaderData } from '@remix-run/react'
//import { Card, CardContent, CardHeader } from '#app/components/ui/card.tsx'
import { Suspense } from 'react'
import getRecent from './getRecent.server'
import Recent from './Recent'

export async function loader() {
  const recent = getRecent()

  return { recent }
}

export default function HansardIndex() {
  const { recent } = useLoaderData<typeof loader>() || { recent: undefined }

  return (
    <main className="h-full overflow-auto px-8">
      <h1 className="mb-4 mt-8 text-3xl font-bold">Hansard</h1>

      {/*
      <div className="mb-8 grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <h2 className="text-lg font-bold">Calendar</h2>
          </CardHeader>
          <CardContent>
            <p>View the calendar of events</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <h2 className="text-lg font-bold">Members</h2>
          </CardHeader>
          <CardContent>
            <p>View the list of members</p>
          </CardContent>
        </Card>
      </div>
      */}
      <Suspense fallback={<div>Loading...</div>}>
        <Await resolve={recent}>{recent => <Recent recent={recent} />}</Await>
      </Suspense>
    </main>
  )
}
